import React from "react";
import { Link } from "react-router-dom";
import LineChart from "../../charts/LineChart01";
import Icon from "../../images/icon-01.svg";
import EditMenu from "../../components/DropdownEditMenu";

// Import utilities
import { tailwindConfig, hexToRGB, formatValue } from "../../utils/Utils";

function DashboardCard01({
  labels,
  newData,
  returningData,
  loading,
  newTotal,
  returningTotal,
  unit,
}) {
  const chartData = {
    labels: labels,
    datasets: [
      // Indigo line
      {
        data: newData,
        fill: true,
        backgroundColor: `rgba(${hexToRGB(
          tailwindConfig().theme.colors.blue[500]
        )}, 0.08)`,
        borderColor: tailwindConfig().theme.colors.indigo[500],
        borderWidth: 2,
        tension: 0,
        pointRadius: 3,
        pointHoverRadius: 5,
        pointBackgroundColor: tailwindConfig().theme.colors.indigo[500],
        pointHoverBackgroundColor: tailwindConfig().theme.colors.indigo[500],
        pointBorderWidth: 0,
        pointHoverBorderWidth: 0,
        clip: 20,
      },
      // Gray line
      {
        data: returningData,
        fill: true,
        borderColor: `rgba(${hexToRGB(
          tailwindConfig().theme.colors.emerald[500]
        )}, 0.80)`,
        backgroundColor: `rgba(${hexToRGB(
          tailwindConfig().theme.colors.emerald[500]
        )}, 0.08)`,
        borderWidth: 2,
        tension: 0,
        pointRadius: 0,
        pointHoverRadius: 5,
        pointBackgroundColor: `rgba(${hexToRGB(
          tailwindConfig().theme.colors.emerald[500]
        )}, 0.80)`,
        pointHoverBackgroundColor: `rgba(${hexToRGB(
          tailwindConfig().theme.colors.emerald[500]
        )}, 0.80)`,
        pointBorderWidth: 0,
        pointHoverBorderWidth: 0,
        clip: 20,
      },
    ],
  };

  return (
    <div className="col-span-full xl:col-span-6 bg-white dark:bg-theme-surface-accent shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 h-[430px]">
      <div className="px-5 pt-5">
        <h2 className="text-lg font-semibold text-slate-800 dark:text-slate-100 mb-2">
          New vs Returning Customer Revenue
        </h2>
        {loading ? (
          <div className="flex items-start">
            <div className="text-lg font-bold text-slate-800 dark:text-slate-100 mr-16">
              <span className="absolute">
                <svg
                  className="animate-spin w-4 h-4 fill-current shrink-0"
                  viewBox="0 0 16 16"
                >
                  <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                </svg>
              </span>
            </div>
          </div>
        ) : (
          <div className="flex items-start">
            <div className="text-lg font-bold text-slate-800 dark:text-slate-100 mr-16">
              <div className={"text-blue-600"}>New</div>
              {formatValue(newTotal)}
            </div>
            <div className="text-lg font-bold text-slate-800 dark:text-slate-100 mr-2">
              <div className={"text-emerald-600"}>Returning</div>

              {formatValue(returningTotal)}
            </div>
          </div>
        )}
      </div>
      {/* Chart built with Chart.js 3 */}
      <div className="grow max-sm:max-h-[128px] xl:max-h-[300px]">
        {/* Change the height attribute to adjust the chart height */}
        {!loading && (
          <LineChart
            data={chartData}
            width={389}
            height={300}
            yFormatter={formatValue}
            unit={unit}
          />
        )}
        {loading && (
          <div className="flex items-center justify-center h-full">
            <div className="text-slate-800 dark:text-slate-100">Loading...</div>
          </div>
        )}
      </div>
    </div>
  );
}

export default DashboardCard01;
